import { hasRole } from './permissionsUtils';

export const getDynamicPath = (role) =>
  hasRole(role, ['admin']) ? '/admin-panel' : '/';

export const getVisibleNavLinks = (role, allNavLinks) => {
  if (role === 'fueler') {
    return allNavLinks.filter(
      ({ path }) =>
        path !== '/accounting-report' && path !== '/truck-consumption'
    );
  }
  if (role === 'accountant') {
    return allNavLinks.filter(
      ({ path }) => path !== '/' && path !== '/truck-consumption'
    );
  }
  return allNavLinks;
};
